import { Injectable, OnDestroy } from '@angular/core';
import { UiCommandEvent } from '@ui/cer-ui-types';
import { BehaviorSubject, Subject, Subscription } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CerStepperService implements OnDestroy {

  private subscriptionManager$: Subscription = new Subscription();

  public parentData: BehaviorSubject<object> = new BehaviorSubject<object>(undefined);
  public formCommand$: Subject<UiCommandEvent> = new Subject<UiCommandEvent>();
  public childCommand$: Subject<UiCommandEvent> = new Subject<UiCommandEvent>();


  constructor() {
  }

  public ngOnDestroy(): void {
    this.subscriptionManager$.unsubscribe();
  }
}
